import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAddClassToTabPanels]',
  standalone: true,
})
export class AddClassToTabPanelsDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    const tabViewPanels =
      this.el.nativeElement.querySelector('.p-tabview-panels');
    if (tabViewPanels) {
      this.renderer.addClass(tabViewPanels, 'p-card');
    }
  }
}
